import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import * as React from 'react'
import { twMerge } from 'tailwind-merge'

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
    isWithPortal?: boolean
  }
>(({ className, sideOffset = 4, isWithPortal = false, ...props }, ref) => {
  const content = (
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={twMerge(
        'animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-40 overflow-hidden rounded-md border bg-white px-3 py-1.5 text-sm text-zinc-800 shadow-md',
        className,
      )}
      {...props}
    />
  )
  return isWithPortal ? (
    <TooltipPrimitive.Portal>{content}</TooltipPrimitive.Portal>
  ) : (
    content
  )
})
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
